import { useEffect, useState } from 'react';

function OrganizationIcon({ iconUrl, name, className = '' }) {
  const [loadFailed, setLoadFailed] = useState(false);
  const initial = (name || 'O').trim().charAt(0).toUpperCase() || 'O';

  useEffect(() => {
    setLoadFailed(false);
  }, [iconUrl]);

  return (
    <span className={className} aria-hidden="true">
      {iconUrl && !loadFailed ? (
        <img
          src={iconUrl}
          alt=""
          decoding="async"
          referrerPolicy="no-referrer"
          onError={() => setLoadFailed(true)}
        />
      ) : initial}
    </span>
  );
}

export default OrganizationIcon;
